import React from 'react';
import mainTpl from '../templates/pension';
import BaseNewCardView from '../../../../Cards/views/BaseNewCardView';

export default class extends BaseNewCardView {
    template = mainTpl;

    constructor(props) {
        super(props);

        this.state = {
            ...this.state,
            ui: this.uiStates.INITIAL,
            tab: 'tariffs'
        };
    }

    static displayName = 'Pension.Views.Main';
}
